import React from 'react';

import CuroLoader from 'components/curo-components/common/CuroLoader';

import styles from './ApplicationProcessStep.module.scss';

const LoaderStep = () => {
  return (
    <div className={styles.centeredMain}>
      <CuroLoader />
      <p>One moment while we review your application</p>
    </div>
  );
};

export default LoaderStep;
